import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const projects = [
  {
    title: "Panneaux solaires",
    field: "Nettoyage & rendement",
    img: "/uploads/solaire.jpg",
    alt: "Panneaux solaires sur toiture en tuiles canal — photo du chantier",
  },
  {
    title: "Climatisation",
    field: "Nettoyage & désinfection",
    img: "https://images.unsplash.com/photo-1726614846573-c1ac2e6161d1?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Unité de climatisation murale blanche",
  },
  {
    title: "Toiture & gouttières",
    field: "Nettoyage & entretien",
    img: "/uploads/toiture.jpg",
    alt: "Toiture en tuiles canal et gouttière — photo du chantier",
  },
  {
    title: "Tous travaux",
    field: "Réparations & aménagements",
    img: "/uploads/travaux.jpg",
    alt: "Mur en pierre réalisé — photo du chantier",
  },
];

const WorkItem = ({ p, i }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [-50, 50]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1] }}
      className={`group ${i === 1 ? "md:mt-40" : ""} ${i === 2 ? "md:-mt-24" : ""} ${i === 3 ? "md:mt-24" : ""}`}
      data-testid={`work-item-${i + 1}`}
    >
      <div className="overflow-hidden aspect-[3/4] border border-white/10">
        <motion.img
          style={{ y }}
          src={p.img}
          alt={p.alt}
          className="w-full h-[115%] object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-[1.5s] ease-out"
          data-testid={`work-image-${i + 1}`}
        />
      </div>
      <div className="flex items-baseline justify-between mt-6">
        <div>
          <h3 className="font-serif text-2xl md:text-3xl tracking-tight group-hover:text-gold transition-colors duration-700">
            {p.title}
          </h3>
          <p className="text-xs uppercase tracking-[0.25em] text-ash mt-2">{p.field}</p>
        </div>
      </div>
    </motion.div>
  );
};

export const Works = () => (
  <section
    id="realisations"
    className="px-6 md:px-12 py-32 md:py-48 border-t border-white/10"
    data-testid="works-section"
  >
    <div className="flex items-end justify-between mb-24">
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
        className="font-serif text-5xl md:text-7xl tracking-tighter leading-none"
        data-testid="works-title"
      >
        nos<br />
        <span className="italic font-light text-gold">interventions</span>
      </motion.h2>
      <p className="hidden md:block text-xs uppercase tracking-[0.3em] text-ash">
        Devis gratuit
      </p>
    </div>
    <div className="grid md:grid-cols-2 gap-12 md:gap-20">
      {projects.map((p, i) => (
        <WorkItem key={p.title} p={p} i={i} />
      ))}
    </div>
  </section>
);
